/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import 'react-telephone-input/css/default.css';
import CustomFields from '../../../../components/customFields/CustomFields';
import SectionHeader from '../../../../components/sectionHeader';
import PERMITMODULE from '../../../../icons/PERMITMODULE.png';
import DEFAULTFIELDS from './DEFAULTFIELDS';
import styles from '../initiateForm/form.module.scss';
import Button from '../../../../components/button';
import HeaderBack from '../../../../components/headerBack';
import { changeCurrentPage } from '../../../../general_redux/actions';
import { fetchspecificAdpLogs, initiateApplication, getAdpDefaultFields, getPortalUsers,
  clearState, handleClearInitiateState, checkInitiatePermit } from '../../redux/action';
import Loading from '../../../../components/loading';
import Spinner from '../../../../components/spinner';
import Modal from '../../../../components/modal';

const InitiateForm=(props) => {
  const logId=props?.match?.params?.id;
  const dispatch=useDispatch();
  const { history }= props;
  const [currentUser, setCurrentUser]=useState({});
  const [state, setState]=useState({
    answers: {
      application_type: 'New'
    },
    formErrors: false
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors]=useState({});
  const loader= useSelector(states => states?.permitManagement?.adpInitiationStatus);
  const loaderForRenewal= useSelector(states => states?.permitManagement?.loader);
  const profile = useSelector(states => states.auth.profile);
  const ADPDEFAULTFIELDS = useSelector(states => states?.permitManagement?.adpDefaultFields);
  const adpSchema = useSelector(states => states?.permitManagement?.adpSchema);
  const portalUsers = useSelector(states => states?.permitManagement?.portalUsers);
  const submitStatus = useSelector(states => states?.permitManagement?.adpInitiationStatus);
  const initiateStatus = useSelector(states => states?.permitManagement?.checkInitiatedPermitAction);
  const initiatedPermitData = useSelector(states => states?.permitManagement?.initiatedPermitData);
  const [airfieldWorker, setAirfieldWorker] = useState(false);
  const [initiatedModal, setInitiatedModal] = useState(false);
  const newApplicaitonFields = DEFAULTFIELDS.map((ele) => {
        if (ele.id === 'application_type') {
        return {
          ...ele,
            values: [{
                    key: 'New',
                    value: 'New'
                }]
        };
        } return { ...ele };
    });
  const [initFormFields, setInitFormFields] = useState(newApplicaitonFields);
  useEffect(() => {
    if (logId) {
      dispatch(fetchspecificAdpLogs(logId));
    }
  }, [dispatch, logId]);

  useEffect(() => {
    if (profile && portalUsers) {
      setCurrentUser(portalUsers?.find(ele => ele?.id === profile?.id));
    }
  }, [portalUsers, profile]);

  useEffect(() => {
    if (adpSchema) {
      let designation_title = adpSchema?.default_fields?.default_field?.find(ele => ele?.id === 'designation')?.title || 'Designation';
      let updatedFormFields = initFormFields.map(
        (ele) => {
          if (ele.id === 'designation' && designation_title) {
            return { ...ele, title: designation_title };
          }
          return { ...ele };
        }
        );
      setInitFormFields(updatedFormFields);
    }
  }, [adpSchema]);

  useEffect(() => {
    dispatch(changeCurrentPage(profile?.permit_management?.driver_permit || 'ADP'));
    dispatch(getPortalUsers(profile?.tenant?.[0]?.id));
    setAirfieldWorker(Object.keys(profile?.permissions||{}).length===1 && Object.keys(profile?.permissions)?.[0] === 'airfield_worker_driver_permit');
  }, []);

  useEffect(() => {
    if (submitStatus?.success) {
      dispatch(clearState());
      history.push('/adp/myapplications');
    }
  }, [submitStatus, history]);

  useEffect(() => {
    const answer = { ...(state?.answers||{}) };
    const error = { ...errors };
    if (currentUser) {
        if (currentUser?.first_name) {
            answer.first_name = currentUser?.first_name;
            errors.first_name = false;
        }
        answer.last_name = currentUser?.last_name;
        answer.email = currentUser?.email;
        answer.phone = currentUser?.phone || ' ';

        setState({ ...state, answers: answer });
        setErrors(error);
    }
  }, [currentUser]);
  useEffect(() => {
    dispatch(getAdpDefaultFields());
  }, [dispatch]);

  useEffect(() => {
    if (initiateStatus?.success) {
      setIsLoading(false);
      if (initiatedPermitData?.length > 0) {
        setInitiatedModal(true);
        dispatch(handleClearInitiateState());
      } else {
        dispatch(handleClearInitiateState());
        handelSubmit(true);
      }
    }
  }, [initiateStatus, dispatch, initiatedPermitData]);

  const handleCheckInitatePermits = () => {
    let phone = (state?.answers?.phone).trim() || undefined;
    let email = state?.answers?.email || undefined;
    let initiated_to = profile.id;
    dispatch(checkInitiatePermit(phone, email, initiated_to, undefined));
  };

  const handleAnswerChanged = (answer, fieldId) => {
    setState({ ...state, answers: { ...state.answers, [fieldId]: answer } });
  };

  const handelSubmit = async (checkPermit) => {
    const fieldError = errors;
    if (state.answers.application_type === '') {
      fieldError.application_type = true;
    } else {
      fieldError.application_type = false;
    }
    if (ADPDEFAULTFIELDS?.enableSingleName && ADPDEFAULTFIELDS?.selectedName) {
      if (ADPDEFAULTFIELDS?.selectedName==='lastName') {
        fieldError.last_name = false;
      } if (ADPDEFAULTFIELDS?.selectedName==='firstName') {
        fieldError.first_name = false;
      }
    }
    if (!logId && !checkPermit) {
      handleCheckInitatePermits();
      return;
    }

    const noErrors = Object.keys(fieldError)
      .every(k => (errors[k] === false));
    if (noErrors && checkPermit) {
      setIsLoading(true);
      const data = { ...state.answers };
      data.phone = data.phone[0] + data.phone.slice(1).replace(/[^\d]/g, '');
      data.initiated_to = profile.id;
      await dispatch(initiateApplication(data));
      setState({ ...state, formErrors: false });
    } else {
      setState({ ...state, formErrors: true });
    }
  };

  const getRequired = (data) => {
    let requiredKeys = {};
    data.forEach((ele) => {
      if (ele.required) {
        requiredKeys = { ...requiredKeys, [ele.id]: true };
      }
      if (ADPDEFAULTFIELDS?.enableSingleName) {
        if (ADPDEFAULTFIELDS?.selectedName === 'firstName') {
          if (ele.required && ele.id==='first_name') {
            requiredKeys = { ...requiredKeys, [ele.id]: false };
          }
        } else if (ele.required && ele.id==='last_name') {
          requiredKeys = { ...requiredKeys, [ele.id]: false };
        }
      }
    });
    return requiredKeys;
  };
  const getErrors = (data) => {
    let requiredKeys = {};
    data.forEach((ele) => {
      if (ele.required && !state?.answers?.[ele?.id]) {
        requiredKeys = { ...requiredKeys, [ele.id]: true };
      } else {
        requiredKeys = { ...requiredKeys, [ele.id]: false };
      }
      if (ADPDEFAULTFIELDS?.enableSingleName) {
        if (ADPDEFAULTFIELDS?.selectedName === 'firstName') {
          if (ele.required && ele.id==='first_name') {
            requiredKeys = { ...requiredKeys, [ele.id]: false };
          }
        } else if (ele.required && ele.id==='last_name') {
          requiredKeys = { ...requiredKeys, [ele.id]: false };
        }
      }
    });
    return requiredKeys;
  };

  const handleFieldErrorChanged = (id, value) => {
    setErrors({ ...errors, [id]: value });
  };

  useEffect(() => {
    setErrors(getErrors(DEFAULTFIELDS));
  }, [state.answers]);


  return <>
    <Loading loadingStatus={loader.loading || (loaderForRenewal && logId)} />
    <SectionHeader
      icon={PERMITMODULE}
      translationID=" "
      defaultTitle={`New ${profile?.permit_management?.driver_permit || 'ADP'} Application`}
      centered
      {...props}
    />
    <HeaderBack
      translationID="workorder.settings.back"
      translationDefault="Back"
    />
    <div className={styles.container}>
      <div className={styles.headder}>
        <FormattedMessage
          id=" "
          defaultMessage={`New ${profile?.permit_management?.driver_permit || 'ADP'} Application Form`}
        />
      </div>
      <span className={styles.note}>
        <FormattedMessage
          id="application.note"
          defaultMessage="Please note: "
          tagName="b"
        />
        <FormattedMessage
          id=" "
          defaultMessage={`Renewal ${profile?.permit_management?.driver_permit || 'ADP'}
            applications should be submitted through the existing application`}
        />
      </span>
      <div style={{ padding: '20px' }}>
        <CustomFields
          handleAnswerChanged={(a, b) => handleAnswerChanged(a, b)}
          handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
          showFormErrors={state.formErrors}
          requiredMap={getRequired(initFormFields)}
          fields={initFormFields}
          answers={state.answers}
          airfieldWorker={airfieldWorker}
          driver
          forQuestionMarkHelp
        />
      </div>
      <div className={styles.submitButton}>
        <Spinner active={(isLoading || initiateStatus?.loading) && !loader.loading} />
        <Button
          action="secondary"
          onClick={() => (handelSubmit(false))}
          translationID="adp.submit"
          defaultText={logId? 'Renew' : 'Submit'}
          disabled={isLoading || initiateStatus?.loading}
        />
      </div>
    </div>
    <Modal
      showIn={initiatedModal}
      onClose={() => setInitiatedModal(false)}
      minHeight="150px"
      width="554px"
    >
      <div style={{ padding: '20px 20px 10px' }}>
        <FormattedMessage
          id="adp.application.restriction.warning.message.one"
          tagName="h5"
          defaultMessage={` An ${profile?.permit_management?.driver_permit || 'ADP'}
            application has already been initiated for this user.
            Kindly cancel the existing one if you need to re-initiate an application.
           `}
        />
        <FormattedMessage
          id="adp.application.restriction.warning.message.two"
          tagName="h5"
          defaultMessage={'For renewal of an approved application, please initiate the renewal from within the application itself.'}
        />
      </div>
      <div className={styles.submitButton}>
        <Button
          action="secondary"
          onClick={() => setInitiatedModal(false)}
          translationID="inspections.list.ok"
          defaultText="OK"
          />
      </div>
    </Modal>
         </>;
};
export default InitiateForm;
